module.exports = __webpack_public_path__ + "static/media/orat-img-001.7ff969c7.jpg";